<template>
  <div class="page-container">
    <div class="filter-container">
      <el-form size="small" :inline="true">
        <el-form-item :label="item.label" v-for="item in departmentAllFilter" :key="item.label">
          <el-date-picker
            type="datetimerange"
            v-if="item.type === 'datetimerange'"
            v-model="form[item.start + '_' + item.end]"
            :default-time="['00:00:00', '23:59:59']"
            value-format="timestamp"
          ></el-date-picker>
          <el-input v-else v-model="form[item.prop]"></el-input>
        </el-form-item>
        <div class="btn-container">
          <el-button size="small" type="primary" @click="onSearch">查询</el-button>
          <el-button size="small" @click="onReset">清空</el-button>
        </div>
      </el-form>
    </div>
    <div class="table-container">
      <el-table stripe :data="tableData" size="small">
        <el-table-column :label="item.label" v-for="item in departmentAllTable" :key="item.label">
          <template slot-scope="scope">
            <el-image v-if="item.prop==='name'" :src="department_icons[scope.row.type]" style="width: 32px;"/>
            <span v-if="item.filter">{{ item.filter(scope.row) }}</span>
            <span v-else>{{ scope.row[item.prop] }}</span>
            <span v-if="item.prop==='mobile' && scope.row.loginName">
              <br/>
              <el-tooltip content="医生账号登录别名(可选)" placement="right">
                <el-tag >{{scope.row.loginName}}</el-tag>
              </el-tooltip>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <template>
              <el-button type="text" size="small" @click="handleEdit(scope.row, 'edit')" style="margin-right: 20px">编辑
              </el-button>
              <el-button type="text" size="small" v-if="canResetPassword" @click="handleResetPasswd(scope.row.userId)"
                         style="margin-right: 20px">修改密码
              </el-button>

              <!--              冻结-->
              <el-popover
                placement="bottom"
                trigger="manual"
                v-if="scope.row.enabled===1"
                v-model="scope.row.disableShow">
                <div style="display: flex;font-size: 12px;align-items: center;margin-bottom: 10px;">
                  请输入安全密码：
                  <el-input type="password" size="small" style="width: 110px" v-model="verify"></el-input>
                </div>
                <div style="display: flex;justify-content: flex-end;">
                  <el-button type="text" size="small" @click="verify = '';scope.row.disableShow = false">取消
                  </el-button>
                  <el-button size="small" type="primary" @click="handleStatus(scope.row.localId, 2)">确定
                  </el-button>
                </div>
                <el-button type="text" size="small" slot="reference" style="margin-right: 20px"
                           @click="scope.row.disableShow=true">冻结
                </el-button>
              </el-popover>
              <!--              解冻-->
              <el-popover
                placement="bottom"
                trigger="manual"
                v-else
                v-model="scope.row.enabledShow">
                <div style="display: flex;font-size: 12px;align-items: center;margin-bottom: 10px;">
                  请输入安全密码：
                  <el-input type="password" size="small" style="width: 110px" v-model="verify"></el-input>
                </div>
                <div style="display: flex;justify-content: flex-end;">
                  <el-button type="text" size="small" @click="verify = '';scope.row.enabledShow = false">取消
                  </el-button>
                  <el-button size="small" type="primary" @click="handleStatus(scope.row.localId, 1)">确定
                  </el-button>
                </div>
                <el-button type="text" size="small" slot="reference" style="margin-right: 20px"
                           @click="scope.row.enabledShow=true">解冻
                </el-button>
              </el-popover>
              <!--              删除-->
              <el-popover
                placement="bottom"
                trigger="manual"
                v-model="scope.row.visible">
                <div style="display: flex;font-size: 12px;align-items: center;margin-bottom: 10px;">
                  请输入安全密码：
                  <el-input type="password" size="small" style="width: 110px" v-model="verify"></el-input>
                </div>
                <div style="display: flex;justify-content: flex-end;">
                  <el-button type="text" size="small" @click="verify = '';scope.row.visible = false">取消
                  </el-button>
                  <el-button size="small" type="primary" @click="handleDel(scope.row, scope.$index)">确定
                  </el-button>
                </div>
                <el-button slot="reference" type="text" size="small" @click="scope.row.visible = true">删除
                </el-button>
              </el-popover>

              <el-button type="text" size="small" v-if="isAdmin"
                         @click="handleChangeAgent(scope.row)"
                         style="margin-right: 20px">更换代理商
              </el-button>
              <el-button type="text" size="small" v-if="isAdmin&&scope.row.agentName"
                         @click="handleCancelAgent(scope.row)"
                         style="margin-right: 20px">解绑代理商
              </el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        layout="total, prev, slot, next, jumper"
        :current-page="pageNo"
        :page-size="pageSize"
        :page-count="pageCount"
        :total="pageTotal"
        prev-text="上一页"
        next-text="下一页"
        @current-change="onPageChange"
      >
        <span>{{ pageNo }}/{{ pageCount }}</span>
      </el-pagination>
    </div>

    <el-dialog title="重置密码" :visible.sync="dialogResetPassword" width="30%" center>
      <el-form label-position="left" label-width="80px">
        <el-form-item prop="verify" label="安全密码">
          <el-input v-model="verify" placeholder="请输入安全密码"></el-input>
        </el-form-item>
        <el-form-item prop="pass"
                      :rules="[{ pattern: /^(\w){6,18}$/, message: '请输入正确密码（6-18位,字母,数字,下划线）', trigger: 'blur'  }]"
                      label="新密码">
          <el-input v-model="pass" min="6" max="18" placeholder="(6-18位,字母,数字,下划线)"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogResetPassword = false">取 消</el-button>
        <el-button type="primary" @click="doResetPasswd()">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="更换代理商" :show-close="false" :visible="dialogChangeAgent||dialogCancelAgent" width="40%" center>
      <el-form label-position="left" label-width="120px">
        <el-form-item label="当前科室账号">
          <span
            class="row-dep">{{ changeAgentRow.hospitalName }} - {{ changeAgentRow.name }} - {{
              changeAgentRow.doctorName
            }} - {{ changeAgentRow.mobile }}</span>
        </el-form-item>
        <el-form-item label="当前所属代理商">
          <span class="row-agent">{{ changeAgentRow.agentName ? changeAgentRow.agentName : '暂无代理商' }}</span>
        </el-form-item>
        <el-form-item prop="verify" label="安全密码">
          <el-input v-model="verify" placeholder="请输入安全密码"></el-input>
        </el-form-item>
        <el-form-item prop="agent" v-if="dialogChangeAgent"
                      label="代理商">
          <el-select v-model="agentUserId" placeholder="请选择代理商">
            <el-option
              v-for="item in agentList"
              :key="item.userId"
              :label="item.agentName"
              :value="item.userId">
              <span style="float: left">{{ item.agentName }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.username }}</span>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogChangeAgent = false;dialogCancelAgent=false">取 消</el-button>
        <el-button type="primary" @click="doChangeAgent">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
import * as R from 'ramda';
import moment from 'moment';
import {login as loginApi, task as taskApi} from '@/api';
import {isAdmin} from '@/utils';
import {mapState} from 'vuex';
import departmentIcon0 from '@/assets/department/department_icon_0.png';
import departmentIcon1 from '@/assets/department/department_icon_1.png';
import departmentIcon2 from '@/assets/department/department_icon_2.png';
import departmentIcon3 from '@/assets/department/department_icon_3.png';
import departmentIcon4 from '@/assets/department/department_icon_4.png';
import departmentIcon5 from '@/assets/department/department_icon_5.png';
import departmentIcon6 from '@/assets/department/department_icon_6.png';
import departmentIcon7 from '@/assets/department/department_icon_7.png';
import departmentIcon9 from '@/assets/department/department_icon_9.png';

export default {
  name: 'departmentManage',
  data() {
    return {
      departmentAllFilter: [],
      departmentAllTable: [],

      form: {},

      pageSize: 15,
      pageCount: 0,
      pageNo: 1,
      pageTotal: 0,
      canResetPassword: false,
      dialogResetPassword: false,
      id: '',
      pass: '',
      verify: '',
      tableData: [],

      dialogChangeAgent: false,
      dialogCancelAgent: false,
      changeAgentRow: '',
      agentList: [],
      localId: '',
      agentUserId: '',

      department_icons: [
        departmentIcon0,
        departmentIcon1,
        departmentIcon2,
        departmentIcon3,
        departmentIcon4,
        departmentIcon5,
        departmentIcon6,
        departmentIcon7,
        null,
        departmentIcon9,
      ]
    };
  },
  computed: {
    ...mapState('common', ['userInfo']),
    operates: ({$route}) => $route.meta.operates,
    isAdmin() {
      const {role} = this.userInfo;
      return isAdmin(role);
    },
  },
  methods: {
    handleDel(row, index) {
      if (!this.verify) {
        this.$message.error('请输入安全密码！');
        return;
      }
      taskApi.departmentDelete({
        localId: row.localId,
        verify: this.verify
      })
        .then(res => {
          if (res.code === 10000) {
            this.$message.success('删除成功！');
            this.verify = '';
            this.$set(this.tableData[index], 'visible', false);
            this.onSearch();
          }
        });
    },
    handleEdit(row, pageType) {
      this.$router.push({
        path: `/account/department/edit/${row.localId}`,
        query: {
          hospitalId: row.hospitalLocalId,
          hospitalName: row.hospitalName,
          pageType,
          pageNo: this.pageNo
        }
      });
    },
    async lazyLoad(node, resolve) {
      const {data} = await taskApi.areasList({
        code: node.value || ''
      });
      resolve(data.map(e => ({
        value: e.code,
        label: e.name,
        leaf: e.level >= 2
      })));
    },
    handleStatus(localId, status) {
      if (!this.verify) {
        this.$message.error('请输入安全密码！');
        return;
      }
      taskApi.departmentDisable({
        localId,
        verify: this.verify,
        status
      })
        .then((res) => {
          if (res.code === 10000) {
            if (status === 1) {
              this.$message.success('解冻科室账号成功！');
            } else {
              this.$message.success('冻结科室账号成功！');
            }
            this.onSearch();
          }
        });
    },
    getForm() {
      const {departmentAllFilter} = this.$route.meta;
      const form = {};
      R.forEach(({type, prop, start, end}) => {
        form[prop] = '';
      }, departmentAllFilter);
      this.form = form;
    },
    onOperateClick(row, item) {
      const {onClick} = item;
      if (onClick) {
        onClick(row, this);
      }
    },
    onReset() {
      this.getForm();
    },
    onCreated() {
      const {departmentAllFilter, departmentAllTable} = this.$route.meta;
      this.departmentAllFilter = departmentAllFilter;
      this.departmentAllTable = departmentAllTable;
      this.getForm();
      this.query();
    },
    onSearch() {
      this.query();
    },
    onPageChange(pageNo) {
      this.query(pageNo);
    },
    async query(pageNo) {
      const {fetchDataName} = this.$route.meta;
      this.pageNo = pageNo || this.pageNo;
      const submitForm = {};
      R.forEachObjIndexed((value, key) => {
        if (!value) return;
        const filterItem = R.find(R.propEq('prop', key), this.departmentAllFilter) || {};
        if (/_/.test(key)) { // 是 datetimerange
          if (R.isEmpty(value)) return;
          const [startKey, endKey] = key.split('_');
          const [startValue, endValue] = value;
          submitForm[startKey] = moment(startValue).format('YYYY-MM-DD HH:mm:ss');
          submitForm[endKey] = moment(endValue).format('YYYY-MM-DD HH:mm:ss');
        } else {
          submitForm[key] = filterItem.dataType === 'number' ? Number(value) : String(value);
        }
      }, this.form);
      submitForm.pageNo = this.pageNo;
      submitForm.pageSize = this.pageSize;

      let isEmpty = true;
      const formKeys = R.keys(this.form);
      R.forEach((key) => {
        const value = this.form[key];
        if (
          (R.is(Array, value) && !R.isEmpty(value)) ||
          (R.is(String, value) && (value !== '')) ||
          (R.is(Number, value))
        ) {
          isEmpty = false;
        }
      }, formKeys);
      let rq;
      if (isEmpty) {
        rq = taskApi[fetchDataName];
      } else {
        rq = taskApi['departmentListName'];
        const {status} = this.$route.meta;
        if (!R.isNil(status)) {
          submitForm.status = status;
        }
      }
      const res = await rq(submitForm);
      if (res.code === 10000) {
        const {pageCount, data, total} = res.data;
        this.pageCount = pageCount;
        this.pageTotal = total;
        data.forEach(e => {
          e.visible = false;
        });
        this.tableData = data;
      }
    },

    /**
     * 修改密码
     */
    handleResetPasswd(id) {
      this.id = id;
      this.dialogResetPassword = true;
    },
    async doResetPasswd() {
      const res = await loginApi.resetPassword({id: this.id, pass: this.pass, verify: this.verify});
      if (res.code === 10000) {
        this.dialogResetPassword = false;
        this.$message.success('修改成功！');
        this.pass = '';
        this.verify = '';
      } else {
        this.$message.error(res.msg);
      }
    },
    // 更换代理商
    async handleChangeAgent(row) {
      this.changeAgentRow = row;
      this.localId = row.localId;
      this.dialogChangeAgent = true;
      const res = await taskApi.agentList({pageNo: 1, pageSize: 999});
      if (res.code === 10000) {
        this.agentList = res.data.data;
      } else {
        this.$message.error(res.msg);
      }
    },
    // 解绑代理商
    handleCancelAgent(row) {
      this.changeAgentRow = row;
      this.localId = row.localId;
      this.dialogCancelAgent = true;
    },
    // 解绑/更换代理商
    async doChangeAgent() {
      const res = await taskApi.changeAgent({
        localId: this.localId,
        agentUserId: this.agentUserId,
        verify: this.verify
      });
      if (res.code === 10000) {
        this.dialogCancelAgent = false;
        this.dialogChangeAgent = false;
        this.changeAgentRow = '';
        this.localId = '';
        this.agentUserId = '';
        this.verify = '';
        this.$message.success('修改成功！');

        this.onPageChange(this.pageNo);
      } else {
        this.$message.error(res.msg);
      }
    }
  },
  created() {
    if (this.$route.meta.pageNo) {
      this.pageNo = parseInt(this.$route.meta.pageNo);
    }
    this.onCreated();
    if (this.isAdmin) {
      this.canResetPassword = true;
    }
  },
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/DepartmentManage/index.vue